var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTimeoffSailboat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_26405)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_69_26405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4846 16.5001H8.5154L8.1404 15.0001H15.8596L15.4846 16.5001H16.5154L16.9851 14.6212C17.0035 14.5475 17.0049 14.4705 16.9891 14.3962C16.9733 14.3219 16.9408 14.2522 16.894 14.1923C16.8473 14.1324 16.7875 14.084 16.7192 14.0507C16.6509 14.0174 16.576 14.0001 16.5 14.0001H14V12.5001H16.5C16.5839 12.5001 16.6665 12.479 16.7401 12.4387C16.8137 12.3984 16.876 12.3403 16.9212 12.2696C16.9664 12.1989 16.9932 12.118 16.9989 12.0343C17.0047 11.9506 16.9892 11.8668 16.9541 11.7906L13.9541 5.29061C13.918 5.21242 13.8623 5.14487 13.7925 5.0945C13.7226 5.04413 13.641 5.01264 13.5554 5.00309C13.4698 4.99353 13.3832 5.00624 13.3039 5.03996C13.2247 5.07369 13.1555 5.1273 13.1031 5.19561L8.10375 11.6954C8.04687 11.7694 8.01184 11.8578 8.00262 11.9507C7.99341 12.0436 8.01038 12.1372 8.05162 12.2209C8.09285 12.3047 8.15671 12.3752 8.23595 12.4245C8.31519 12.4739 8.40666 12.5 8.5 12.5001H13V14.0001H7.5C7.42404 14.0001 7.34908 14.0174 7.28082 14.0507C7.21256 14.084 7.15278 14.1325 7.10603 14.1923C7.05928 14.2522 7.02679 14.3219 7.01101 14.3962C6.99524 14.4705 6.9966 14.5475 7.015 14.6212L7.4846 16.5001ZM14 7.77641L15.7185 11.5001H14V7.77641ZM9.5154 11.5001L13 6.97006V11.5001H9.5154Z",
    fill: "#A56EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4529 16.8756C17.3698 17.1977 17.1819 17.483 16.9189 17.6865C16.6559 17.8901 16.3326 18.0004 16 18.0001C15.6595 17.9802 15.3326 17.8595 15.0609 17.6532C14.7892 17.447 14.585 17.1646 14.4743 16.8419C14.4407 16.7427 14.3769 16.6564 14.2919 16.5951C14.2068 16.5338 14.1048 16.5006 14 16.5001C13.8953 16.4993 13.7931 16.5318 13.7081 16.5927C13.623 16.6537 13.5595 16.7401 13.5266 16.8395C13.4161 17.1626 13.2119 17.4456 12.9401 17.6523C12.6682 17.859 12.3409 17.9801 12 18.0001C11.6595 17.9802 11.3326 17.8595 11.0609 17.6532C10.7892 17.447 10.585 17.1646 10.4743 16.8419C10.4407 16.7427 10.3769 16.6564 10.2919 16.5951C10.2068 16.5338 10.1048 16.5006 10 16.5001C9.89501 16.4979 9.79211 16.5297 9.70676 16.5909C9.6214 16.6521 9.55819 16.7393 9.5266 16.8395C9.41612 17.1626 9.21194 17.4456 8.94007 17.6523C8.66819 17.859 8.34094 17.9801 8 18.0001C7.66739 18.0004 7.34412 17.8901 7.08108 17.6865C6.81805 17.483 6.6302 17.1977 6.5471 16.8756L5.57885 17.1246C5.71707 17.6616 6.02999 18.1373 6.46833 18.4769C6.90668 18.8164 7.44553 19.0005 8 19.0001C8.38804 19.0035 8.77141 18.9153 9.11894 18.7427C9.46647 18.57 9.76834 18.3178 10 18.0065C10.234 18.3152 10.5364 18.5656 10.8834 18.738C11.2304 18.9104 11.6126 19.0001 12 19.0001C12.3874 19.0001 12.7696 18.9104 13.1166 18.738C13.4636 18.5656 13.766 18.3152 14 18.0065C14.2317 18.3178 14.5335 18.57 14.8811 18.7427C15.2286 18.9153 15.612 19.0035 16 19.0001C16.5545 19.0005 17.0933 18.8164 17.5317 18.4769C17.97 18.1373 18.2829 17.6616 18.4212 17.1246L17.4529 16.8756Z",
    fill: "#A56EFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_26405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_69_26405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeoffSailboat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timeoff-sailboat.75238bb46e98c90f14bf806929431302.svg";